export const pageContentQuery = (pageType, contentBuilderKey, contentBuilderFragment) => {
    return `query pageContent($canonicalUid: String) {
        entry(uid: [$canonicalUid]) {
            id
            ... on ${pageType} {
                id
                ${contentBuilderKey} {
                    __typename
                    ${contentBuilderFragment}
                }
            }
        }
    }`
}